import { render, staticRenderFns } from "./V2BuyingSummaryModal.vue?vue&type=template&id=5aa17d12&scoped=true&"
import script from "./V2BuyingSummaryModal.vue?vue&type=script&lang=js&"
export * from "./V2BuyingSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./V2BuyingSummaryModal.vue?vue&type=style&index=0&id=5aa17d12&lang=scss&scoped=true&"
import style1 from "./V2BuyingSummaryModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa17d12",
  null
  
)

export default component.exports